import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";

Vue.use(AclInstaller);

export default new AclCreate({
  initial: "anonymous",
  router: null,
  acceptLocalRules: true,
  globalRules: {
    admin: new AclRule("admin").generate(),
    worker: new AclRule("worker").or("admin").generate(),
    anonymous: new AclRule("anonymous").or("worker").generate(),
  },
});
